/* eslint-disable react/require-default-props */
import {
  Box,
  BoxProps,
  FormControl,
  FormControlProps,
} from '@material-ui/core';
import {
  Control,
  FieldValues,
  useController,
  UseControllerProps,
} from 'react-hook-form';
import { FieldControllerProvider } from './FieldControllerContext';
import { fieldHasError } from './formUtils';

export type FieldControllerProps<
  TFieldValues extends FieldValues = FieldValues
> = FormControlProps &
  BoxProps &
  Pick<
    UseControllerProps<TFieldValues>,
    'name' | 'rules' | 'shouldUnregister' | 'defaultValue'
  > & { control?: Control<TFieldValues> };

const FieldController = <TFieldValues extends FieldValues = FieldValues>({
  name,
  rules,
  shouldUnregister,
  defaultValue,
  control,
  disabled,
  ...props
}: FieldControllerProps<TFieldValues>) => {
  const { fieldState } = useController({
    name,
    rules,
    shouldUnregister,
    defaultValue,
    control,
  });

  return (
    <FieldControllerProvider
      value={{ name, ...(control && { control: control as Control }) }}
    >
      <Box
        component={FormControl}
        error={fieldHasError(fieldState)}
        variant="outlined"
        aria-disabled={disabled}
        {...{ disabled }}
        {...props}
      />
    </FieldControllerProvider>
  );
};

export default FieldController;
